import { Navigate } from "react-router-dom";
import { RouteType } from "../@types/RouteType";
import AdminPage from "../pages/AdminPage/AdminPage.lazy";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AdminDealer from "../components/AdminPage/AdminDealer/AdminDealer";
import AdminGlobalSettings from "../components/AdminPage/AdminGlobalSettings/AdminGlobalSettings";
import AdminInventory from "../components/AdminPage/AdminInventory/AdminInventory.lazy";
import AdminBulletinsTable from "../components/AdminPage/AdminGlobalSettings/AdminBulletinsTable/AdminBulletinsTable.lazy";
import AdminWarrantyRegistrationSearch from "../components/AdminPage/AdminGlobalSettings/AdminWarrantyRegistrationSearch/AdminWarrantyRegistrationSearch.lazy";
import DealerAdminRoutes from "./DealerAdminRoutes";
import AdminLeads from "../components/AdminLeads/AdminLeads.lazy";
import LeadDetail from "../components/LeadDetail/LeadDetail.lazy";
import AdminDealersPage from "../pages/AdminDealersPage/AdminDealersPage.lazy";

const AdminPortalRoutes: RouteType[] = [
    ...DealerAdminRoutes,
    {
        path: "/admin",
        element: <AdminPage />,
        state: "admin",
        displayText: 'Admin',
        sidebarProps: {
            displayText: "Admin",
            icon: <AdminPanelSettingsIcon />,
            id: "AdminNavLink"
        },
        child: [
            {
                index: true,
                element: <Navigate to="/admin/dealers" />,
                state: "admin.dealers",
                displayText: 'Dealers'
            },
            {
                path: "/admin/dealers",
                element: <AdminDealersPage />,
                state: "admin.dealers",
                displayText: "Dealers",
                sidebarProps: {
                    displayText: 'Dealers'
                }
            },
            {
                path: "/admin/dealers/:id",
                element: <AdminDealer />,
                state: "admin.id",
                displayText: "Company"
            },
            {
                path: "/admin/settings",
                element: <AdminGlobalSettings />,
                state: "admin.settings",
                displayText: "Settings",
                sidebarProps: {
                    displayText: 'Settings'
                },
                child: [
                    {
                        index: true,
                        element: <Navigate to="/admin/settings/bulletins" />,
                        state: 'admin.settings',
                        displayText: 'Bulletins'
                    },
                    /* {
                        path: "/admin/settings/general",
                        element: <>GENERAL SETTINGS</>,
                        state: 'adming.settings',
                        displayText: 'General'
                    }, */
                    {
                        path: "/admin/settings/bulletins",
                        element: <AdminBulletinsTable />,
                        state: 'admin.settings.bulletins',
                        displayText: 'Bulletins'
                    },
                    {
                        path: "/admin/settings/warranty-registration-search",
                        element: <AdminWarrantyRegistrationSearch />,
                        state: 'admin.settings.warranty-registration-search',
                        displayText: 'Warranty Registration Search'
                    }
                ]
            },
            {
                path: "/admin/inventory",
                element: <AdminInventory />,
                state: "admin.inventory",
                displayText: "Inventory",
                sidebarProps: {
                    displayText: 'Inventory'
                }
            },
            {
                path: "/admin/leads",
                element: <AdminLeads />,
                state: "admin.leads",
                displayText: "Leads",
                sidebarProps: {
                    displayText: 'Leads'
                }
            },
            {
                path: '/admin/leads/:id',
                element: <LeadDetail />,
                state: 'admin.leads.id',
                displayText: "Lead"
            }
        ]
    }
]

export default AdminPortalRoutes;